import React, { useState } from 'react'

import { getSum } from 'services/helpers'

import { BookingsSumSheetRow } from './components/BookingsSumSheetRow';

const tableCellStyles = {
  border: '1px solid #b9b9b9',
  padding: '2px'
};

const tableStyles = {
  pageBreakBefore: 'always',
  width: '100%',
  fontSize: 11,
  textAlign: 'center',
  borderCollapse: 'collapse',
};

const tfootStyles = {
  textAlign: 'left',
  fontWeight: 'bold'
};

const columnData = [
  { label: '#' },
  { label: 'Дата' },
  { label: 'Маршрут' },
  { label: 'Звідки' },
  { label: 'Куди' },
  { label: 'Прізвище' },
  { label: 'Імя' },
  { label: 'Телефон' },
  { label: 'Ціна' },
];

export const BookingsSumSheet = ({ bookings, convert }) => {
  const [pricesUa, setPricesUa] = useState([])
  const [pricesPl, setPricesPl] = useState([])
  const [pricesCz, setPricesCz] = useState([])

  let i = 1;

  const bookingRows = bookings.map((booking) => (
    <BookingsSumSheetRow
      i={i++}
      key={booking.id}
      convert={convert}
      setPricesUa={setPricesUa}
      setPricesPl={setPricesPl}
      setPricesCz={setPricesCz}
      {...booking}
    />
  ));

  const priceSumUa = pricesUa.reduce(getSum, 0);
  const priceSumPl = pricesPl.reduce(getSum, 0);
  const priceSumCz = pricesCz.reduce(getSum, 0);

  return (
    <table style={tableStyles}>
      <thead>
        <tr>
          {columnData.map(({ label }, i) => <th style={i === 0 ? { width: '3%' } : {}} key={label}>{label}</th>)}
        </tr>
      </thead>
      <tbody>
        {bookingRows}
      </tbody>
      <tfoot style={tfootStyles}>
        <tr>
          <td colSpan='8' style={tableCellStyles}>СУМА</td>
          <td style={{ ...tableCellStyles, textAlign: 'right' }}>
            {priceSumUa > 0 ? `${priceSumUa} грн` : null} <br />
            {priceSumPl > 0 ? `${priceSumPl} zl` : null} <br />
            {priceSumCz > 0 ? `${priceSumCz} czk` : null}
          </td>
        </tr>
      </tfoot>
    </table>
  )
}

BookingsSumSheet.defaultProps = {
  convert: false
}



// WEBPACK FOOTER //
// ./src/components/BookingsSumSheet/BookingsSumSheet.js